export function VolkswagenIcon(props: React.HTMLAttributes<SVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1024 1024"
      enableBackground="new 0 0 1400 980"
      aria-hidden="true"
      {...props}
    >
      <path fill="none" d="M0 0h1024v1024H0z" />
      <switch transform="matrix(10.18839 0 0 10.18839 -251.52 -252.793)">
        <g>
          <path d="M-25-25h200v200H-25V-25Z" fill="none" />
          <path
            d="M75 120.4c-24.9 0-45.3-20.5-45.3-45.4 0-5.6 1-10.9 2.9-15.9l26.5 53.3c.3.7.8 1.3 1.6 1.3s1.3-.6 1.6-1.3l12.2-27.3c.1-.3.3-.6.6-.6s.4.3.6.6l12.2 27.3c.3.7.8 1.3 1.6 1.3s1.3-.6 1.6-1.3l26.5-53.3c1.9 5 2.9 10.3 2.9 15.9-.2 24.9-20.6 45.4-45.5 45.4zm0-55.7c-.3 0-.4-.3-.6-.6l-14.2-32c4.6-1.7 9.6-2.6 14.8-2.6 5.2 0 10.2.9 14.8 2.6l-14.2 32c-.2.4-.3.6-.6.6zM60.5 97.6c-.3 0-.4-.3-.6-.6l-23-46.4C41 44.3 46.5 39 53.2 35.3l16.6 36.9c.2.6.7.8 1.2.8h8c.6 0 1-.1 1.3-.8l16.6-36.9c6.6 3.7 12.2 9 16.3 15.3L90 97c-.1.3-.3.6-.6.6s-.4-.3-.6-.6l-8.7-19.8c-.3-.7-.7-.8-1.3-.8h-8c-.6 0-1 .1-1.3.8L61.1 97c-.1.3-.3.6-.6.6zM75 125c27.7 0 50-22.3 50-50s-22.3-50-50-50-50 22.3-50 50 22.3 50 50 50z"
            fill="#001e50"
          />
        </g>
      </switch>
    </svg>
  )
}
